import { AxiosInstance } from 'axios';
import { eidUrl } from 'keys';
import { FrameworkDefaultAxiosInstance } from 'framework/xhr/FrameworkDefaultAxiosInstance';

export const DefaultAxiosInstance = (): AxiosInstance => {
	return FrameworkDefaultAxiosInstance(eidUrl);
};
